import React from 'react';
import ReactDOM from 'react-dom';

const ClientPhotoConsentModal = ({ clientName, onConfirm, onCancel }) => {
    const node = (
        <div className="cpcm-root" onClick={onCancel}>
            <div className="cpcm-card" onClick={(e) => e.stopPropagation()}>
                <div className="cpcm-icon" aria-hidden>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#007EA0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 12l2 2 4-4" />
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                </div>
                <h3 className="cpcm-title">Confirm photo permission</h3>
                <p className="cpcm-body">
                    Please confirm {clientName ? clientName.split(' ')[0] : 'the client'} gave permission
                    for photos to be stored on their record. You will only be asked once.
                </p>
                <div className="cpcm-actions">
                    <button type="button" className="cpcm-btn cpcm-btn--ghost" onClick={onCancel}>
                        Cancel
                    </button>
                    <button type="button" className="cpcm-btn cpcm-btn--primary" onClick={onConfirm}>
                        I have permission
                    </button>
                </div>
            </div>
        </div>
    );
    return typeof document !== 'undefined' ? ReactDOM.createPortal(node, document.body) : node;
};

export default ClientPhotoConsentModal;
